import { render, staticRenderFns } from "./SubscriptionCategoriesForm.vue?vue&type=template&id=796d1fde"
import script from "./SubscriptionCategoriesForm.vue?vue&type=script&lang=ts"
export * from "./SubscriptionCategoriesForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports